import { DEFAULT_PIEVE_MODEL_ID, DEFAULT_PIEVE_REASONING_EFFORT } from '@shared/pieve/defaultModel.js';
import createThread from '@/redux/actions/pieveActions/createThread.js';
import sendPrompt from '@/redux/actions/pieveActions/sendPrompt.js';
import buildRequestInput from './buildRequestInput.js';
import toThreadTitle from './toThreadTitle.js';

/**
 * Opens a new conversation for a request typed on the assistant home and starts its first run.
 * `attachments` are files already uploaded by the composer. Resolves to { success, threadId } or
 * { success: false, message } when the conversation could not be opened.
 */
const startAssistantRequest = ({ prompt, attachments = [] }) => {
  return async (dispatch) => {
    const created = await dispatch(
      createThread({
        title: toThreadTitle(prompt, attachments),
        composerModel: DEFAULT_PIEVE_MODEL_ID,
        composerReasoningEffort: DEFAULT_PIEVE_REASONING_EFFORT,
        hydrateAfterCreate: false,
        waitForHydrate: false
      })
    );
    const threadId = String(created?.id || created?.threadId || '').trim();

    if (!threadId) {
      return { success: false, message: created?.error?.message || 'The conversation could not be opened. Try again.' };
    }

    dispatch(sendPrompt({ threadId, prompt, newUserInput: buildRequestInput({ prompt, attachments }) }));
    return { success: true, threadId };
  };
};

export default startAssistantRequest;
